// extracted by mini-css-extract-plugin
export default {"Checkbox":"archive-header-module__Checkbox--gq2H2"};